import {FileDocument} from "../file-document.model";

export class FileDocumentAndPdfModel {
  document: FileDocument
  fileBinaryBase64: string
  error?: string | null
}
